import moment from 'moment/moment'

export const userBeneficiarioMap = [
  {
    label: 'Nome',
    path: 'dadosPessoais.nome'
  },
  {
    label: 'CPF',
    path: 'dadosPessoais.cpf'
  },
  {
    label: 'Nascimento',
    path: 'dadosPessoais.dataNascimento',
    format: (value) => !moment(value, 'YYYY-MM-DD').isValid() ? '-' : moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
  },
  {
    label: 'Telefone',
    path: 'dadosPessoais.contato.telefoneCelular'
  },
  {
    label: 'E-mail',
    path: 'dadosPessoais.contato.email'
  },
  {
    label: 'Contrato',
    path: 'dadosDoContrato.numeroContrato'
  },
  {
    label: 'Plano',
    path: 'dadosDoPlano.descricao'
  },
  {
    label: 'Matrícula',
    path: 'dadosDoPlano.matricula'
  }
]

export const userPerfilMap = [
  {
    label: 'Nome',
    path: 'nome'
  },
  {
    label: 'CPF',
    path: 'pessoaFisica.cpf'
  },
  {
    label: 'Nascimento',
    path: 'pessoaFisica.dataNascimento',
    format: (value) => !moment(value, 'YYYY-MM-DD').isValid() ? '-' : moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
  },
  {
    label: 'Telefone',
    path: 'contato.telefoneCelular'
  },
  {
    label: 'E-mail',
    path: 'contato.email'
  }
]
